import { render, staticRenderFns } from "./OmsLegend.vue?vue&type=template&id=b4dc5170&scoped=true"
import script from "./OmsLegend.vue?vue&type=script&lang=js"
export * from "./OmsLegend.vue?vue&type=script&lang=js"
import style0 from "./OmsLegend.vue?vue&type=style&index=0&id=b4dc5170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dc5170",
  null
  
)

export default component.exports